import { gql } from '@apollo/client';

export const SEARCH_TAG_TV_PROGRAMS = gql`
  query SearchTagTvPrograms(
    $query: NonEmptyTrimmedString!
    $context: TvSearchContextType!
  ) {
    searchTagTvPrograms(query: $query, context: $context) {
      broadcasts {
        title
        boneUUID
        channel {
          title
        }
        program {
          country
          collectionItemTitle
          boneUUID
        }
        startedAt
        title
      }
      episodes {
        boneUUID
        country
        collection {
          country
          itemIndex
          parentCollection {
            country
            title
          }
        }
        collectionItemIndex
        collectionItemTitle
        title
      }
      movies {
        boneUUID
        country
        releasedYear
        title
      }
      seasons {
        boneUUID
        country
        itemIndex
        parentCollection {
          country
          title
        }
        releasedYear
        title
      }
      series {
        boneUUID
        country
        releasedYear
        title
      }
    }
  }
`;
